<!-- <div class="simulation-cards" *ngIf="!subject || subject == ''">
    <div class="simulation-card" (click)="onClickSimulation(item)" *ngFor="let item of simulationItems;">
        <img src='{{ "assets/simulation-images/" + item.img_src }}' width="200px" height="100px">
        <span>{{item.name}}</span>
    </div>
</div>
<div class="simulation-container" *ngIf="subject && subject != ''">
    <h3 class="heading-margin-popular-courses" *ngIf="subject == 'physics'">Physics</h3>
    <h3 class="heading-margin-popular-courses" *ngIf="subject == 'mathematics'">Mathematics</h3>
    <h3 class="heading-margin-popular-courses" *ngIf="subject == 'biology'">Biology</h3>
    <h3 class="heading-margin-popular-courses" *ngIf="subject == 'chemistry'">Chemistry</h3>
    <div class="simulation-cards">
        <div class="simulation-card" (click)="onClickSimulation(item)" *ngFor="let item of simulationItems;">
            <img src='{{ "assets/simulation-images/" + item.img_src }}' width="200px" height="100px">
            <span>{{item.name}}</span>
        </div>
    </div>
</div>

<img src="../../../../assets/images/" alt=""> -->

<section class="special_cource padding_top">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-xl-5">
                <div class="section_tittle text-center">
                    <h2 *ngIf="subject == 'physics'">Physics</h2>
                    <h2 *ngIf="subject == 'mathematics'">Mathematics</h2>
                    <h2 *ngIf="subject == 'biology'">Biology</h2>
                    <h2 *ngIf="subject == 'chemistry'">Chemistry</h2>
                    <h2 *ngIf="subject == 'all'">All Simulations</h2>
                </div>
            </div>
        </div>
        <div class="row"  *ngIf="subject && subject != ''">
            <div class="col-sm-6 col-lg-4" style="margin-top: 2%; margin-bottom: 2%;" (click)="onClickSimulation(item)" *ngFor="let item of simulationItems;">
                <div class="single_special_cource">
                    <img src='{{ "../../../../assets/images/Simulation/" + item.img_src}}' class="special_img" alt="">
                    <div class="special_cource_text">
                        <a class="btn_4" *ngIf="item.category == 'physics'">Physics</a>
                        <a class="btn_4" *ngIf="item.category == 'mathematics'">Mathematics</a>
                        <a class="btn_4" *ngIf="item.category == 'biology'">Biology</a>
                        <a class="btn_4" *ngIf="item.category == 'chemistry'">Chemistry</a>
                        <h4>Class: {{item.class}}</h4>
                        <a>
                            <h3>{{item.name}}</h3>
                        </a>
                        <p>{{item.desc}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>